import _ from 'lodash';
import { PERSONAL_INFO_SECTION } from '../pages/Guest/ApplyPage/ApplyPageForm/ApplyPageFormConstants';
import { PHONE_TYPE } from '../components/PhoneGroup/PhoneType/PhoneTypeUtils';
import { LOCALE_PREFIX as USER_TITLE_LOCALE_PREFIX } from '../components/UserTitle/UserTitle';
import { sanitizeFormInputOptions } from '../../framework/App/AppUtils';

export const getInitialFormValues = state => ({
    [PERSONAL_INFO_SECTION]: getInitialPersonalInfoValues(state)
});

export const getInitialPersonalInfoValues = state => ({
    userTitle: sanitizeFormInputOptions(
        _.get(state, 'serverData.user.userTitle'),
        Object.keys(_.get(state, `serverData.messages.${USER_TITLE_LOCALE_PREFIX}.userNameTitleOptions`, {})),
        ''
    ),
    firstName: _.get(state, 'serverData.user.firstName'),
    lastName: _.get(state, 'serverData.user.lastName'),
    street1: `${_.get(state, 'serverData.billingAddress.addressLine1', '')} ${_.get(state, 'serverData.billingAddress.addressLine2', '')}`.trim(),
    city: _.get(state, 'serverData.billingAddress.city'),
    state: _.get(state, 'serverData.billingAddress.state'),
    postalCode: _.get(state, 'serverData.billingAddress.postalCode'),
    phoneType: sanitizeFormInputOptions(
        _.get(state, 'serverData.user.phoneType'),
        Object.values(PHONE_TYPE),
        PHONE_TYPE.MOBILE
    ),
    telephone: _.get(state, 'serverData.user.telephone'),
    email: _.get(state, 'serverData.user.email'),
    fullName: `${_.get(state, 'serverData.user.firstName')} ${_.get(state, 'serverData.user.lastName')}`
});
